import React from "react";
import PropTypes from "prop-types";
import styles from "./pptSplitButton.module.scss";

/**
 * Split button component combining a primary action button with a dropdown menu.
 *
 * Provides a unified control where the left side is the primary action (typically
 * a Button) and the right side is a dropdown menu trigger (typically a PopoverButton).
 *
 * The two halves are styled to appear as a single control with:
 * - Matched heights
 * - Merged border between them (no gap or double border)
 * - Squared corners at the seam, rounded on outer edges
 *
 * @example
 * <PPTSplitButton
 *   primaryButton={
 *     <Button onClick={handleClear}>Clear All Filters</Button>
 *   }
 *   dropdownButton={
 *     <PopoverButton>
 *       <MenuList options={options} onChange={handleChange} />
 *     </PopoverButton>
 *   }
 * />
 */
export const PPTSplitButton = ({ primaryButton, dropdownButton }) => {
  return (
    <div className={styles.splitButton}>
      {primaryButton}
      {dropdownButton}
    </div>
  );
};

PPTSplitButton.propTypes = {
  /** The primary action button (left side) */
  primaryButton: PropTypes.node.isRequired,
  /** The dropdown menu button (right side) */
  dropdownButton: PropTypes.node.isRequired,
};

export default PPTSplitButton;
